export default __webpack_public_path__ + "static/media/partner-mock-img.46613211.png";